import wx from 'weixin-js-sdk'
import store from "../store";
// import service from './service'
import Vue from 'vue'
import global from '../Global.vue'
// console.log(global.a)
const wxApi = {

	/**
	 * [wxRegister 微信Api初始化]
	 * @param  {Function} callback [ready回调函数]
	 */
	wxRegister(callback) {

		// get请求获取参数
		// Axios.get(service.service()+'/front/share/wxshare?pageUrl='+encodeURIComponent(location.href.split('#')[0]),{},{}).then((res) => {
		//   // let data = JSON.parse(res.data.data); // PS: 这里根据你接口的返回值来使用
		//   let data=res.data;
		//   wx.config({
		//     debug: false,//生产环境需要关闭debug模式
		//     appId: data.appid,//appId通过微信服务号后台查看
		//     timestamp: data.timestamp,//生成签名的时间戳
		//     nonceStr: data.nonceStr,//生成签名的随机字符串
		//     signature: data.signature,//签名
		//     jsApiList: [
		//       'checkJsApi',
		//       'onMenuShareTimeline',
		//       'onMenuShareAppMessage'
		//     ]
		//   })
		// }).catch((error) => {
		//   console.log(error)
		// })
		// userInfo.isMobile()
		let path = '/api/wxshare/wxshare'
		let params = {
			params: {
				url: window.location.href,
				
				// url:window.location.href.split('//')[1]
				// url:'https://livemanage.vjoevr.com/#/watch?roomId=223'

			}

		}
		// alert(!userInfo.isMobile() ? 'PC' : userInfo.getMobileSystem())
		// console.log(window.location.href.split('//')[1])
		// console.log(window.location.href)
		global.axios
			.get(path, params)
			.then(res => {
				console.log(res)
				let data = res.data.data
				wx.config({
					debug: false, //生产环境需要关闭debug模式
					appId: data.appid, //appId通过微信服务号后台查看
					timestamp: data.timestamp, //生成签名的时间戳
					nonceStr: data.nonceStr, //生成签名的随机字符串
					signature: data.signature, //签名
					jsApiList: [
						'checkJsApi',
						// 'onMenuShareTimeline',
						'updateTimelineShareData',
						// 'onMenuShareAppMessage',
						'updateAppMessageShareData',

					]
				})
				wx.ready((res) => {
					// 如果需要定制ready回调方法
					if (callback) {
						callback()
					}
				})


			}).catch((error) => {
				console.log(error)
			})


	},
	/**
	 * [ShareTimeline 微信分享到朋友圈]
	 * @param {[type]} option [分享信息]
	 * @param {[type]} success [成功回调]
	 * @param {[type]} error   [失败回调]
	 */
	ShareTimeline(option) {


		wx.updateAppMessageShareData({
			title: option.title, // 分享标题
			desc: option.desc, // 分享描述
			link: option.link, // 分享链接
			imgUrl: option.imgUrl, // 分享图标
			success() {
				// 用户成功分享后执行的回调函数

				option.success()
			},
			cancel() {
				// 用户取消分享后执行的回调函数
				option.error()
			}
		})
	},
	/**
	 * [ShareAppMessage 微信分享给朋友]
	 * @param {[type]} option [分享信息]
	 * @param {[type]} success [成功回调]
	 * @param {[type]} error   [失败回调]
	 */
	ShareAppMessage(option) {
		console.log(option)
		wx.updateTimelineShareData({
			title: option.title, // 分享标题
			link: option.link, // 分享链接
			desc: option.desc, // 分享描述
			imgUrl: option.imgUrl, // 分享图标

			success() {
				// 用户成功分享后执行的回调函数
				option.success()
			},
			cancel() {
				// 用户取消分享后执行的回调函数
				option.error()
			}
		})

	}
}
export default wxApi
